/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';


export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFDC2ndApprovedFarmerDetails,
    GetVCCFactoriesByGroupID,
    GetFarmerBankDetailsByFarmerID,
    GetFarmerAccountNumbersByFarmerID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFDC2ndApprovedFarmerDetails(model) {
    const response = await CommonPost('/api/FDC2ndApprovedFarmerDetails/GetFDC2ndApprovedFarmerDetails', null, model);
    return response.data;
}

async function GetFarmerBankDetailsByFarmerID(farmerID) {
    const response = await CommonGet('/api/FDC2ndApprovedFarmerDetails/GetFarmerBankDetailsByFarmerID', 'farmerID=' + parseInt(farmerID));
    return response.data;
}

async function GetFarmerAccountNumbersByFarmerID() {
    const response = await CommonGet('/api/FDC2ndApprovedFarmerDetails/GetFarmerAccountNumbersByFarmerID', null);
    return response.data;
}
